import Panel from '../../../common/layout/Panel'
import DataResource from '../../../common/v4/DataResource';
import Tabs from '../../../common/Tabs';

const SmsMasterCodesList = () => {
    const data = {
        url: '/admin/products/sms_master_codes',
        data: {
            data: [],
            metadata: []
        },
        userFilterSimple: true,
        userFilterExpandable: false,
        onclick: 'link',
        link: '/products/sms_master_codes/{id}',
        metadata: [
            {
                source: 'ATRSMSMASTERCODEID',
                label: 'SMS Master Code ID',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'ATRNAME',
                label: 'Name',
                type: 'text',
            },
            {
                source: 'ATRISOCOUNTRY',
                label: 'ISO Code',
                type: 'text',
            },
            {
                source: 'ATRSTATUS',
                label: 'Enabled',
                type: 'boolean',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    const tabs = [
        {
            name: 'SMS Master Codes',
            link: '/products/sms_master_codes'
        },
        {   
            name: 'Prefixes',
            link: '/products/sms_master_codes/prefixes'
        }
    ]
    return (
        <div>
            <Tabs tabs={tabs} />
            <Panel title = "SMS Master Codes"> 
            <DataResource
                addButtonText = "Create SMS Master Code"
                addButtonLink = "/products/sms_master_codes/create"                    
                data = {data}
            />
        </Panel></div>
    )
}   

export default SmsMasterCodesList;